/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { submitDtfEvent } from "common/utils/mixpanel/submit-dtf-events";
import { BUSINESS_LINE } from "common/utils/app-registry/contants";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import { useDtfStore } from "./store";
import { useSpanglesStore } from "./spangles-module";
import { useState } from "react";
import { cn } from "tailwind-variants";
import "./DtfSpanglesActions.scss";

export default function DtfSpanglesActions({ isArtworkInvalid = false, ...restProps }) {
  const store = useDtfStore();
  const spanglesStore = useSpanglesStore();
  const [resizeCounter, setResizeCounter] = useState(-1);

  function artworks() {
    // @ts-expect-error TS(4111): Property 'artworks' comes from an index signature,... Remove this comment to see the full error message
    return store.artworks;
  }

  function removeBgLoading() {
    // @ts-expect-error TS(4111): Property 'removeBgLoading' comes from an index sig... Remove this comment to see the full error message
    return store.removeBgLoading;
  }

  function lastSpangledDimensions() {
    // @ts-expect-error TS(4111): Property 'lastSpangledDimensions' comes from an in... Remove this comment to see the full error message
    return spanglesStore.lastSpangledDimensions;
  }

  function spanglesLoading() {
    // @ts-expect-error TS(4111): Property 'spanglesLoading' comes from an index sig... Remove this comment to see the full error message
    return spanglesStore.spanglesLoading;
  }

  function spangleSizeEdited() {
    // @ts-expect-error TS(4111): Property 'spangleSizeEdited' comes from an index s... Remove this comment to see the full error message
    return spanglesStore.spangleSizeEdited;
  }

  function spangleSizeEditing() {
    // @ts-expect-error TS(4111): Property 'spangleSizeEditing' comes from an index ... Remove this comment to see the full error message
    return spanglesStore.spangleSizeEditing;
  }

  function originalArtworkUrl() {
    // @ts-expect-error TS(4111): Property 'originalArtworkUrl' comes from an index ... Remove this comment to see the full error message
    return spanglesStore.originalArtworkUrl;
  }

  function allAPIsCompleted() {
    // @ts-expect-error TS(4111): Property 'allAPIsCompleted' comes from an index si... Remove this comment to see the full error message
    return spanglesStore.allAPIsCompleted;
  }

  function invalidSpangleSelected() {
    // @ts-expect-error TS(4111): Property 'invalidSpangleSelected' comes from an in... Remove this comment to see the full error message
    return spanglesStore.invalidSpangleSelected;
  }

  function firstArtwork() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return artworks()[0];
  }

  function isSpangleItButtonDisabled() {
    // @ts-expect-error TS(2339): Property 'width' does not exist on type 'unknown'.
    const { width, height } = lastSpangledDimensions();
    const { width: originalWidth, height: originalHeight } = firstArtwork();
    const isDimensionSame =
      parseFloat(width) === parseFloat(originalWidth) &&
      parseFloat(height) === parseFloat(originalHeight);
    return (
      !allAPIsCompleted() ||
      isArtworkInvalid ||
      removeBgLoading() ||
      (spangleSizeEditing() && isDimensionSame)
    );
  }

  function isButtonDisabled() {
    return spanglesLoading() || !allAPIsCompleted();
  }

  function showEditSizeButton() {
    return spangleSizeEdited() && !invalidSpangleSelected();
  }

  function showSpangleItButton() {
    return !spangleSizeEdited() || spanglesLoading() || invalidSpangleSelected();
  }

  function spangleItButtonLabel() {
    return allAPIsCompleted() && !spanglesLoading() ? "Spangle It!" : "Loading...";
  }

  function getSpangleVariations(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return spanglesStore.getSpangleVariations(...args);
  }

  function setSpangleMode(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return spanglesStore.setSpangleMode(...args);
  }

  function updateArtworkValues(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return store.updateArtworkValues(...args);
  }

  function changeMode(mode: any) {
    setSpangleMode(mode);
  }

  function logResizeCounter() {
    const newCounter = invalidSpangleSelected() ? resizeCounter : resizeCounter + 1;
    setResizeCounter(newCounter);
    submitDtfEvent("spangle_button_clicked", {
      artwork_url: originalArtworkUrl(),
      resize_counter: newCounter,
      business_line: BUSINESS_LINE.SPANGLE
    });
  }

  function spangleIt() {
    const processTimeStamp = Date.now();
    logResizeCounter();
    if (firstArtwork().spangled) {
      updateArtworkValues({
        index: 0,
        spangled: false,
        spangledImageUrl: null
      });
    }
    updateArtworkValues({
      index: 0,
      processTimeStamp,
      isLoading: true,
      progress: 100,
      currentProgress: 0
    });
    getSpangleVariations({
      isRetry: invalidSpangleSelected(),
      processTimeStamp
    });
  }

  return (
    <div {...restProps} className={cn("spangle-actions scope-f7214a82")}>
      {showEditSizeButton() ? (
        <button
          className={cn(
            "spangle-actions__button spangle-actions__button--secondary scope-f7214a82"
          )}
          // @ts-expect-error TS(2322): Type 'unknown' is not assignable to type 'boolean ... Remove this comment to see the full error message
          disabled={isButtonDisabled()}
          type="button"
          onClick={() => {
            changeMode("edit-size");
          }}
          data-testid="spangle-actions-button"
        >
          {" "}
          Edit Size{" "}
        </button>
      ) : null}
      {spangleSizeEditing() ? (
        <button
          className={cn("spangle-actions__button spangle-actions__button--text scope-f7214a82")}
          // @ts-expect-error TS(2322): Type 'unknown' is not assignable to type 'boolean ... Remove this comment to see the full error message
          disabled={isButtonDisabled()}
          type="button"
          onClick={() => {
            changeMode("size-edited");
          }}
          data-testid="spangle-actions-button-1"
        >
          {" "}
          Cancel{" "}
        </button>
      ) : null}
      {showSpangleItButton() ? (
        <button
          className={cn("spangle-actions__button spangle-actions__button--primary scope-f7214a82")}
          // @ts-expect-error TS(2322): Type 'unknown' is not assignable to type 'boolean ... Remove this comment to see the full error message
          disabled={isSpangleItButtonDisabled()}
          type="button"
          onClick={spangleIt}
          data-testid="spangle-actions-button-2"
        >
          <UseSvg
            className={cn("spangle-actions__spangle-icon scope-f7214a82")}
            icon="spangle-wand"
            data-testid="spangle-actions-spangle-icon"
          />{" "}
          {spangleItButtonLabel()}
        </button>
      ) : null}
    </div>
  );
}
